import type {
  QuestionOptionTranslationInput,
  QuestionTranslationInput,
} from 'src/graphql';
import type {
  QuestionOptionTranslationData,
  QuestionTranslationData,
} from 'src/types/formQuestionnaire';

export function toQuestionTranslationInputs(
  translations?: QuestionTranslationData[] | null,
): QuestionTranslationInput[] | undefined {
  if (!translations?.length) return undefined;
  const mapped = translations
    .filter((t) => t.languageCode.trim() && t.questionText.trim())
    .map((t) => {
      const d = t.description?.trim();
      return {
        languageCode: t.languageCode.trim(),
        questionText: t.questionText.trim(),
        description: d && d.length > 0 ? d : null,
      };
    });
  return mapped.length ? mapped : undefined;
}

export function toOptionTranslationInputs(
  translations?: QuestionOptionTranslationData[] | null,
): QuestionOptionTranslationInput[] | undefined {
  if (!translations?.length) return undefined;
  const mapped = translations
    .filter((t) => t.languageCode.trim() && t.optionText.trim())
    .map((t) => ({
      languageCode: t.languageCode.trim(),
      optionText: t.optionText.trim(),
    }));
  return mapped.length ? mapped : undefined;
}
